import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PaperSubmission from "./pages/PaperSubmission";
import PaperSubmissionWithJSON from "./pages/PaperSubmissionWithJSON";
import PaperList from './pages/PaperList';
import { CookiesProvider } from 'react-cookie';
import AdminTools from './pages/AdminTools';


function App() {
  return (
    <CookiesProvider>
      <Router>
        <Routes>
          <Route path="/paper_submission" element={<PaperSubmission />} />
          <Route path="/paper_submission_with_json" element={<PaperSubmissionWithJSON />} />
          <Route path="/" element={<PaperList />} />
          <Route path="/admintools" element={<AdminTools />} />
        </Routes>
      </Router>
    </CookiesProvider>
  );
}

export default App;
